enum BiteLogLrsTableTrackerEvent {
  GetIpAddressSuccess = 1,
  GetIpAddressError = 2,
  GetIpAddressFromStorageCache = 3,
  ValidateIpAddressSuccess = 4,
  ValidateIpAddressError = 5,
  GetAccessTokenSuccess = 11,
  GetAccessTokenWaiting = 12,
  GetAccessTokenError = 13,
  GetAccessTokenSaveWarning = 14,
  GetAccessTokenSaveSuccess = 15,
  ValidateAccessTokenSuccess = 16,
  ValidateAccessTokenError = 17,
  ActivateOrderSuccess = 21,
  ActivateOrderError = 22,
  ActivateOrderSkipped = 23, // log only used in GCN. For vitrine we only call lrs if user select pager number.
  LrsConnected = 30,
  LrsDisconnected = 31,
  LrsFailed = 32,
  LrsStateChanged = 40,
}

export { BiteLogLrsTableTrackerEvent };
